import {Component, OnDestroy, OnInit} from '@angular/core';
import {SectionComponent} from '../../../../../elements/section/section.component';
import {TitleBackgroundComponent} from '../../../../../elements/title-background/title-background.component';
import {ActivatedRoute, Router} from '@angular/router';
import {RunningLineComponent} from '../../../../../elements/running-line/running-line.component';
import {MainBusyBeeComponent} from '../../../../main/items/main-busy-bee/main-busy-bee.component';
import {Card} from '../../../../../../model/cards';
import {MainBestHotelsComponent} from '../../../../main/items/main-best-hotels/main-best-hotels.component';
import {MainDestinationsComponent} from '../../../../main/items/main-destinations/main-destinations.component';
import {HeaderService} from '../../../../../../services/header-service';
import {scrollUp} from '../../../../../../functions/scroll-up';
import {Text} from '../../../../../../model/text';
import {LocationDto} from '../../../../../../model/continent';
import {ContinentService} from '../../../../../../services/continent-service';
import {CountryService} from '../../../../../../services/country-service';
import {PaginationParams} from '../../../../../../model/pagination';
import {CityService} from '../../../../../../services/city-service';
import {environment} from '../../../../../../environments/environment';
import {LoopedSliderComponent} from '../../../../../elements/looped-slider/looped-slider.component';
import {NgIf} from '@angular/common';
import {HotelDtoService} from '../../../../../../services/hotel-dto-service';
import {Continent} from '../../../../../../model/circle';
import {FooterService} from '../../../../../../services/footer-service';
import {RouteService} from '../../../../../../services/route-service';
import {NavigationService} from '../../../../../../services/navigation-service';
import {getCssNumber} from '../../../../../../functions/getCssNumber';
import {findIconByCss, findTextByCss} from '../../../../../../functions/findIconByAlt';
import {findLastNumber} from '../../../../../../functions/getDays';
import {AdminPreviewComponent} from '../../../../../elements/admin-preview/admin-preview.component';
import {TokenStorageService} from '../../../../../../services/token.storage.service';
import {findFirstContinent, findFirstCountry} from '../../../../../../functions/findFirstCityUrl';
import {
  BackgroundLoopedSliderComponent
} from '../../../../../elements/background-looped-slider/background-looped-slider.component';
import {getFirstSentence} from '../../../../../../functions/getFirstSentence';
import {Subscription} from 'rxjs';
import {MenuService} from '../../../../../../services/menu-services';
import {LoadingService} from '../../../../../../services/loading-service';

@Component({
  selector: 'app-country-page',
  imports: [
    SectionComponent,
    TitleBackgroundComponent,
    RunningLineComponent,
    MainBusyBeeComponent,
    MainBestHotelsComponent,
    MainDestinationsComponent,
    LoopedSliderComponent,
    NgIf,
    AdminPreviewComponent,
    BackgroundLoopedSliderComponent,
  ],
  templateUrl: './country-page.component.html',
  standalone: true,
  styleUrl: './country-page.component.scss'
})
export class CountryPageComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected interfaceService: HeaderService,
    protected continentService: ContinentService,
    protected countryService: CountryService,
    protected cityService: CityService,
    protected routeService: RouteService,
    protected hotelService: HotelDtoService,
    public footerService: FooterService,
    public navigationService: NavigationService,
    protected tokenStorageService: TokenStorageService,
    protected menuService: MenuService,
    public loadingService: LoadingService,) {}

  country: string[] = [];
  continent: string[] = [];
  urlCountry: string = '';
  urlContinent: string = '';
  loading: boolean = false;
  loadingCircle: boolean = false;
  idCountry: number = 0;

  adminDisplay: boolean = false;
  uncorrectedUrl: boolean = false;
  displayPageFalse: boolean = false;

  countryDto: LocationDto = new LocationDto();
  continentDto: LocationDto = new LocationDto();
  cityDto: LocationDto = new LocationDto();
  citiesDto: LocationDto[] = [];
  routesDto: LocationDto[] = [];
  typeContent: string | undefined = undefined;

  defaultParams =  new PaginationParams({
    sort: 'titleEn:ASC',
    query: '',
    pageSize: 1000,
    pageNumber: 0,
  });

  grid: number = 4.2;

  isMobile: boolean = false;

  params: PaginationParams = new PaginationParams(this.defaultParams);

  hotelPaginationParams: PaginationParams = {
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: 'rating:asc',
    countryId: ''
  };

  routePaginationParams: PaginationParams = {
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: '',
    continentId: ''
  };

  countryBusyBeeTitle: Text[] = [
    {text: ['Стоит  ', 'Recommended   '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['увидеть', ' '], },
  ];
  countryExclusiveTitle: Text[] = [
    {text: ['Варианты ', 'Travel '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['маршрутов', 'Ideas']}
  ];

  sliderCards: Card[] = [];
  countryEventCards: Card[] = [];
  hotelCards: Card[] = [];
  routeCards: Card[] = [];

  countryBestHotelsTitle: Text[] = [
    {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['отели', 'Hotels']}
  ];

  private routeSub!: Subscription;

  ngOnInit() {
    if (window.innerWidth < 769) {
      this.isMobile = true;
      if (window.innerWidth < 456) {
        this.grid = 1.3;
      } else {
        this.grid = 2.1;
      }
    }
    this.menuService.setMobileSpecialStyle(true);
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    this.getCorrectTitle();
    this.routeSub = this.route.params.subscribe(params => {
      const newCountryName = params['countryName'];
      const newContinentName = params['name'];
      if (newCountryName !== this.urlCountry || newContinentName !== this.urlContinent) {
        this.getCorrectTitle();
      }
    });
  }

  ngOnDestroy() {
    this.menuService.setMobileSpecialStyle(false);
    this.interfaceService.setHeaderStyle(false);
    this.footerService.setFooterColor('rgba(57, 122, 158, 1)');
    this.footerService.setFooterImage('');
    this.footerService.setFooterStyle('');
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  getHotels() {
    return this.hotelCards;
  }

  getCorrectLocation() {
    if (this.countryDto == null) {
      return new LocationDto(this.countryService.getRandom());
    } else {
      this.countryDto.destinationsText = [{text: ['страна', 'country']}];
      return this.countryDto;
    }
  }

  goToDestination(continent: Continent) {
    const continentUrl = continent.url?.toLowerCase().replaceAll(" ", "-");
    const url = `/destinations/${continentUrl}`;
    this.router.navigate([url]).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  getCorrectTitle() {
    this.loading = true;
    this.checkLoading();
    const x = this.route.snapshot.paramMap.get('countryName') ?? 'add';
    const z = this.route.snapshot.paramMap.get('name') ?? 'add';
    this.urlCountry = x.toLowerCase();
    this.urlContinent = z.toLowerCase();
    this.countryService.getCountryByUrl(x).subscribe((data) => {
      this.countryDto = data;
      this.countryDto.button = false;
      this.typeContent = this.countryDto.id?.toString();
      if (this.countryDto.url === ''  || this.countryDto.continent?.url === '') {
        if (this.tokenStorageService.getToken() !== undefined) {
          this.adminDisplay = true;
          this.uncorrectedUrl = true;
        } else {
          this.navigationService.backOrHome();
        }
      }
      if (this.countryDto.displayPage === false) {
        if (this.tokenStorageService.getToken() !== undefined) {
          this.adminDisplay = true;
          this.displayPageFalse = true;
        } else {
          this.navigationService.backOrHome();
        }
      }
      this.footerService.setFooterColor(this.countryDto.continent?.footerColor ?? 'rgba(57, 122, 158, 1)');
      this.footerService.setFooterImage(this.countryDto.footerImage ?? '');
      this.footerService.setFooterStyle(this.countryDto.cssStyleFooterImage ?? '');
      this.country = [this.countryDto.titleRu ?? '', this.countryDto.titleEn ?? ''];
      this.continent = [this.countryDto.continent?.titleRu ?? '', this.countryDto.continent?.titleEn ?? ''];
      this.urlContinent = this.countryDto.continent?.url ?? '';
      this.idCountry = this.countryDto.id ?? 0;
      this.routePaginationParams.continentId = this.countryDto.continent?.id?.toString() ?? '';
      this.countryEventCards = [];
      this.sliderCards = [];
      this.hotelCards = [];
      this.routeCards = [];
      this.citiesDto = [];
      this.countryEventCards = this.countryDto.events.map(c => new Card({
        id: c.id,
        title: [c.titleRu ?? '', c.titleEn ?? ''],
        text: [c.descriptionRu ?? '', c.descriptionEn ?? ''],
        img: c.image ? environment.s3Prefix + c.image : '/app/assets/images/desert.jpg',
        style: c.cssStyle ?? '',
        cssStyle: c.cssStyle ?? '',
        flex: '',
        button: true,
        link: '/feedback',
        anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
        feedValue: [{text: ['Другое', 'Other']}],
      }));
      const ru = this.getExclusiveText(this.countryDto.continent?.titleRu);
      this.sliderCards = this.countryDto.carousels.map((v, index) => {
        const continentCarousel = this.countryDto.continent?.carousels[index];
        if (continentCarousel === undefined) {
          return new Card({
            title: [],
            text: [],
            img: '',
            style: '',
          })
        }
        return new Card({
          id: v.id,
          title: [],
          text: [],
          img: environment.s3Prefix + v.image,
          style: v.cssStyle ?? '',
          cssStyle: v.cssStyle ?? '',
          flex: '',
          cloud: {
            title: [continentCarousel.cloudTitleRu ?? '', continentCarousel.cloudTitleEn ?? ''],
            text: [{text: [continentCarousel.cloudDescriptionRu ?? '', continentCarousel.cloudDescriptionEn ?? '']}],
            link: findTextByCss(continentCarousel.cssStyle, 'link'),
            icon1: findIconByCss(continentCarousel.cssStyle, 'icon', 1),
            icon2: findIconByCss(continentCarousel.cssStyle, 'icon', 2),
            icon3: findIconByCss(continentCarousel.cssStyle, 'icon', 3),
            textEn1: findTextByCss(continentCarousel.cssStyle, 'textEn', 1),
            textEn2: findTextByCss(continentCarousel.cssStyle, 'textEn', 2),
            textEn3: findTextByCss(continentCarousel.cssStyle, 'textEn', 3),
            textRu1: findTextByCss(continentCarousel.cssStyle, 'textRu', 1),
            textRu2: findTextByCss(continentCarousel.cssStyle, 'textRu', 2),
            textRu3: findTextByCss(continentCarousel.cssStyle, 'textRu', 3),
            paddingTop: 0,
            top: getCssNumber(continentCarousel.cssStyle, 'top') ?? 50,
            left: getCssNumber(continentCarousel.cssStyle, 'left') ?? 50,
          }
        });
      });
      this.hotelPaginationParams.countryId = this.idCountry.toString();
      this.hotelService.getHotelList(this.hotelPaginationParams).subscribe((data) => {
        this.hotelCards = (data.content ?? []).map(v => {
          const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
          let link: string | null;
          if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
            link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
              v.city?.url + '/' + v?.url;
          } else {
            link = null
          }
          let descrRu = '';
          let descrEn = '';
          if (v.descriptionRu !== undefined) {
            descrRu = getFirstSentence(v.descriptionRu);
          }
          if (v.descriptionEn !== undefined) {
            descrEn = getFirstSentence(v.descriptionEn);
          }
          return new Card(
            {
              title: ['', ''],
              text: [v.titleRu, v.titleEn],
              img: path,
              style: v.backgroundStyle?.toString() ?? '',
              button: false,
              link: link,
              rating: v.rating ?? 0,
              anotherButton: true,
              anotherHotelButton: true,
              anotherButtonText: [{text: [descrRu, descrEn]}],
            },
          )
        });
      });
      this.routeService.getRouteList(this.routePaginationParams).subscribe((data) => {
        this.routesDto = data.content ?? [];
        const routesInCurrentCountry: Card[] = [];
        const otherRoutes: Card[] = [];
        this.routesDto.forEach(v => {
          let continentUrl = 'continent';
          let countryUrl = 'country';
          const routeUrl = v.url;
          const continent = findFirstContinent(v.points);
          const country = findFirstCountry(v.points);
          if (continent !== undefined) {
            continentUrl = continent.url;
          }
          if (country !== undefined) {
            countryUrl = country.url;
          }
          const link = `/destinations/${continentUrl}/${countryUrl}/route/${routeUrl}`;
          let countEn = '';
          let countRu = '';
          v.points.forEach((p) => {
            if (p.titleEn !== undefined && p.titleEn.length > 0) {
              countEn = findLastNumber(p.titleEn, 'en');
            }
            if (p.titleRu !== undefined && p.titleRu.length > 0) {
              countRu = findLastNumber(p.titleRu, 'ru');
            }
          });
          const card = new Card({
            id: v.id,
            title: [v.titleRu ?? '', v.titleEn ?? ''],
            text: [country?.descriptionRu ?? '', country?.descriptionEn ?? ''],
            img: v.image ? environment.s3Prefix + v.image : '/app/assets/images/desert.jpg',
            style: '',
            flex: '',
            tag: countEn,
            tagRu: countRu,
            button: true,
            link: link,
            anotherButtonText: [{text: ['Исследовать', 'Discover']}]
          });
          if (countryUrl === this.urlCountry) {
            routesInCurrentCountry.push(card);
          } else {
            otherRoutes.push(card);
          }
        });
        this.routeCards = [...routesInCurrentCountry, ...otherRoutes];
      });
      this.continentService.getContinentByUrl(this.urlContinent).subscribe((data) => {
        this.continentDto = data ?? new LocationDto();
        this.cityService.getCityListByCountry(this.params, this.idCountry, true).subscribe((data) => {
          this.citiesDto = data.content ?? [];
          this.citiesDto.forEach(city => {
            const eventCards = city.events.map(event => new Card({
              id: event.id,
              title: [event.titleRu ?? '', event.titleEn ?? ''],
              text: [event.descriptionRu ?? '', event.descriptionEn ?? ''],
              img: event.image ? environment.s3Prefix + event.image : '/app/assets/images/desert.jpg',
              style: event.cssStyle ?? '',
              flex: '',
              tag: event.tag,
              tagRu: event.tagRu,
              button: true,
              link: '/feedback',
              anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
              feedValue: [{text: ['Другое', 'Other']}],

            }));
            this.countryEventCards.push(...eventCards);
          });
          this.loading = false;
          this.checkLoading();
        });
      });
    });
    if (window.innerWidth < 769) {
      // this.countryBestHotelsTitle = [
      //   {text: ['Luxury ', 'Luxury '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
      //   {text: ['Stays', 'Stays'], textTransform: 'uppercase'}
      // ];
    }
  }

  getExclusiveText(continent: string | undefined){
    if (continent === undefined) {
      return ''
    }
    if (continent === 'Ближний Восток' || continent === 'Австралия & Океания') {
      return `Эксклюзивный ${continent}`;
    } else {
      return `Эксклюзивная ${continent}`;
    }
  }

  openCity() {
    scrollUp();
    this.router.navigate(['destinations/' + this.urlContinent + '/' + this.urlCountry + '/' + this.cityDto.url]).then(r => r);
  }

  openRoute() {
  }

  loadCircle(event: boolean) {
    this.loadingCircle = event;
    this.checkLoading();
  }

  checkLoading() {
    if (this.loading || this.loadingCircle) {
      this.loadingService.setLoadingValue(true);
    }
    if (!this.loading && !this.loadingCircle) {
      this.loadingService.setLoadingValue(false);
    }
  }

  protected readonly window = window;
}
